export const getOnlyNumbers = s => {
  return `${s.replace(/\D/g, '')}`;
};

export const formatAsPhoneNumber = s => {
  return getOnlyNumbers(s).replace(/(\d{1,2})(\d{1})?(\d{1,3})?(\d{1,4})?/, function (match, p1, p2, p3, p4) {
    return `${p1 ? `(${p1}` : ''}${p2 ? `${p2})` : ''}${p3 ? ` ${p3}` : ''}${p4 ? `-${p4}` : ''}`;
  });
};

export const getPhoneFormat = phoneNumber => {
  const phoneParts = phoneNumber.split('x');

  return `${getOnlyNumbers(phoneParts[0]).length === 10 ? formatAsPhoneNumber(phoneParts[0]) : phoneParts[0].trim()}${
    phoneParts[1] ? ` x ${phoneParts[1].trim()}` : ''
    }`;
};
